import { cn } from '@/true-fsd/shared/utils/css'
import classes from './MediaErrorPlaceholder.module.scss'

/**
 * Типы ошибок медиа
 */
export type MediaErrorType =
    | 'no_media'
    | 'load_failed'
    | 'invalid_format'
    | 'unsupported_format'
    | 'unknown'

/**
 * Параметры для компонента заглушки ошибки медиа
 */
export interface MediaErrorPlaceholderProps {
    /**
     * Тип ошибки
     */
    errorType?: MediaErrorType
    /**
     * Сообщение об ошибке (опционально)
     */
    message?: string
    /**
     * Дополнительный CSS класс
     */
    className?: string
}

/**
 * Компонент заглушки для отображения ошибок загрузки медиа
 */
export function MediaErrorPlaceholder({
    errorType = 'unknown',
    message,
    className,
}: MediaErrorPlaceholderProps) {
    const getErrorContent = () => {
        switch (errorType) {
            case 'no_media':
                return {
                    title: 'Медиа не найдено',
                    description:
                        'Для этого креатива не найдено медиа. Выберите креатив с изображением или видео.',
                }
            case 'load_failed':
                return {
                    title: 'Ошибка загрузки медиа',
                    description:
                        'Не удалось загрузить медиа. Проверьте подключение к интернету или попробуйте позже.',
                }
            case 'invalid_format':
            case 'unsupported_format':
                return {
                    title: 'Неподдерживаемый формат',
                    description:
                        'Формат медиа не поддерживается. Используйте изображения (JPG, PNG) или видео (MP4, MOV).',
                }
            default:
                return {
                    title: 'Ошибка загрузки медиа',
                    description:
                        message ||
                        'Произошла ошибка при загрузке медиа. Попробуйте выбрать другой креатив.',
                }
        }
    }

    const { title, description } = getErrorContent()

    return (
        <div className={cn(classes.placeholder, className)}>
            <div className={classes.icon}>
                <svg
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                        fill="currentColor"
                    />
                </svg>
            </div>
            <h3 className={classes.title}>{title}</h3>
            <p className={classes.description}>{description}</p>
        </div>
    )
}
